export default "__VITE_ASSET__C0mJ42eo__"